export default "__VITE_ASSET__7c80f4b9__"